import React from "react";
import { Link } from "react-router-dom";
import { homePageV2Testimonials } from "../content/homePageV2Content";

export function TestimonialsSectionV2() {
  const { items, link } = homePageV2Testimonials;

  return (
    <section className="mh2v2-testimonials mh2v2-section-light">
      <div className="mh2v2-container">
        <h3 className="mh2v2-section-title mh2v2-section-title--center">
          WHAT OTHER MAMAS ARE SAYING:
        </h3>

        <div className="mh2v2-testimonial-list">
          {/* TODO: reviews API */}
          {items.map((item, index) => (
            <article
              className={`mh2v2-testimonial${item.reverse ? " reverse" : ""}`}
              key={item.quote + index}
              style={{
                "--testimonial-image-position": item.imagePosition ?? "50% 40%",
                "--testimonial-image-scale": item.imageScale ?? 1,
              }}
            >
              <div className="mh2v2-testimonial__media">
                <img src={item.image} alt={item.author} />
              </div>
              <div className={`mh2v2-testimonial__content ${item.theme}`}>
                <h4>{item.quote}</h4>
                <p>{item.body}</p>
                <strong>{item.author}</strong>
                <span>{item.meta}</span>
              </div>
            </article>
          ))}
        </div>

        <Link className="mh2v2-link-row" to={link.to}>
          {link.label} →
        </Link>
      </div>
    </section>
  );
}

export default TestimonialsSectionV2;
